/**
 * Muted `›` breadcrumb separators — lower contrast than folder labels.
 * Shared by Site Recordings, Patrol, and Drawing–Videos headers.
 */
export const DRAWING_PATH_SEPARATOR_COLOR = "#B8C0CC";

/**
 * Split drawing directory path into hidden ancestor folder names and immediate parent.
 * Used for breadcrumb-style UX (ellipsis menu + parent + file chip) in recordings and patrol.
 *
 * @param {Record<string, unknown> | null | undefined} drawing
 * @returns {{ hiddenFolders: string[], parentFolder: string | null }}
 */
export function getDrawingPathBreadcrumbSegments(drawing) {
  if (!drawing || typeof drawing.name !== "string") {
    return { hiddenFolders: [], parentFolder: null };
  }
  const raw = String(
    drawing.directory_path || drawing.path || "",
  ).replace(/\\/g, "/");
  const lastSlash = raw.lastIndexOf("/");
  const dirPart =
    lastSlash >= 0 ? raw.slice(0, lastSlash).replace(/\/+$/, "") : "";
  const segments = dirPart
    .split("/")
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
  if (segments.length === 0) {
    return { hiddenFolders: [], parentFolder: null };
  }
  if (segments.length === 1) {
    return { hiddenFolders: [], parentFolder: segments[0] };
  }
  return {
    hiddenFolders: segments.slice(0, -1),
    parentFolder: segments[segments.length - 1] ?? null,
  };
}
